import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { AppSettings } from '../app.settings';

const VERSION_REFRESH = 'version-refresh';

@Injectable()
export class VersionInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((response: any) => {
        if (response instanceof HttpResponse) {
          this.checkApiVersion(response);
        }
        return response;
      })
    );
  }

  private checkApiVersion(response: HttpResponse<any>) {
    if (response.headers.has('x-version')) {
      // console.log('API Version', response.headers.get('x-version'));
      if (response.headers.get('x-version') !== AppSettings.APP_VERSION) {
        if (sessionStorage.getItem(VERSION_REFRESH)) {
          // console.log('close window');
          sessionStorage.removeItem(VERSION_REFRESH);

          // this page must be static and cannot load any data services
          window.location.href = '/assets/html/out-date.html';
        } else {
          sessionStorage.setItem(VERSION_REFRESH, 'true');
          // console.log('reload window');
          window.location.reload();
        }
      }
    }
  }
}
